import React, { Component } from 'react'

import './modalheader.scss'

class ModalHeader extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  render () {
    // Empty header with correct spacing in relation to other headers
    let headerText = () => <h3>&#8203;</h3>
    if (this.props.text) {
      headerText = () => <h3>{this.props.text}</h3>
    }

    return (
      <div className='element-modal-header'>
        {headerText()}
        {this.props.children}
      </div>
    )
  }
}

ModalHeader.defaultProps = {
  text: 'Header text'
}

export default ModalHeader



// WEBPACK FOOTER //
// ./src/app/shared/elements/modalHeader/index.js